const removeEmptyKeys = (obj = {}) => {
  Object.keys(obj).forEach(key => obj[key] === null && delete obj[key]);
};

export const trimFieldValue = value => value.trim();

export default removeEmptyKeys;
